import { useAIExperienceCommonDataContext } from './useAIExperienceCommonData';

export function useEngagementPlatform(): {
    startMessage: (messageId: string, variationId?: string) => Promise<boolean>;
    stopMessage: (messageId: string) => Promise<boolean>;
} {
	const { engagementPlatformApi } = useAIExperienceCommonDataContext();

	if (!engagementPlatformApi) {
		return {
			startMessage: () => {
				return Promise.resolve(false);
			},
			stopMessage: () => {
				return Promise.resolve(false);
			},
		};
	}

	return engagementPlatformApi;
}
